import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { recordStatisticsEvent } from '../../../services/statistics-service';
import dt from '../../../shared/theme';

const Text = styled.div`
  margin-top: 16px;
  font-size: 16px;
  line-height: 120%;
  color: #627484;
  font-weight: ${props => dt(props).theme.fontWeightHeavy};

  ${props => dt(props).theme.isLarge && `
    font-size: 19px;
  `};

  > a {
    color: #627484;
    &:hover {
      text-decoration: underline;
      color: #4B5C69;
    }
  }
`;

export default function Profile({ profile }) {
  const {
    id,
    slug,
    name,
    organization,
  } = profile;

  const handleClick = () => {
    recordStatisticsEvent({
      event: 'link_click',
      statisticable: 'profile',
      id,
      clicked_url: `/contributors/${slug}`,
      page: window.location.pathname,
    });

    return false;
  };

  return (
    <Text>
      <a href={`/contributors/${slug}`} onClick={handleClick}>{name}</a>
      {!!organization && <span>{`, ${organization}`}</span>}
    </Text>
  );
}

Profile.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    organization: PropTypes.string,
  }).isRequired,
};
